<template>
  <div>
    <b-card-code
      title="Filter"
      no-body
    >
      <b-card>
        <b-row
          xl="12"
          sm="12"
          class="mb-2"
        >
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              id="v-Province"
              v-model="updateFilter.province"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="province"
              :reduce="(province) => province.value"
              label="title"
              placeholder="--Select Province --"
              class="w-100"
              @input="onProvinceChange"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              id="v-Regency"
              v-model="updateFilter.regency"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="regency"
              :reduce="(regency) => regency.value"
              label="title"
              placeholder="--Select Regency --"
              class="w-100"
              @input="onRegencyChange"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              id="v-Site"
              v-model="updateFilter.site"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sites"
              :reduce="(sites) => sites.value"
              label="title"
              placeholder="--Select Site --"
              class="w-100"
              @input="onSiteChange"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              v-model="updateFilter.service_status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="ServiceStatusOptions"
              :reduce="(ServiceStatusOptions) => ServiceStatusOptions.value"
              label="title"
              placeholder="Service Status"
              class="w-100"
            />
          </b-col>
        </b-row>
        <b-row
          xl="12"
          sm="12"
          class="mb-2"
        >
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <flat-pickr
              id="start-date-range"
              v-model="updateFilter.start_date"
              class="form-control"
              :config="flatpickrConfig"
              placeholder="Select Start Date Range"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <flat-pickr
              id="end-date-range"
              v-model="updateFilter.end_date"
              class="form-control"
              :config="flatpickrConfig"
              placeholder="Select Start Date Range"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              v-model="updateFilter.device_type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="DeviceTypeOptions"
              :reduce="(DeviceTypeOptions) => DeviceTypeOptions.value"
              label="title"
              placeholder="Device Type"
              class="w-100"
            />
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <v-select
              v-model="updateFilter.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="StatusOptions"
              :reduce="(StatusOptions) => StatusOptions.value"
              label="title"
              placeholder="Status"
              class="w-100"
            />
          </b-col>
        </b-row>
        <b-row
          xl="12"
          sm="12"
        >
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              class="sidebar-center mr-1"
              variant="primary"
              @click="filterDevice"
            >
              <feather-icon icon="SearchIcon" /> Filter
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              class="sidebar-center"
              variant="outline-primary"
              @click="resetFilter"
            >
              <feather-icon icon="SearchIcon" /> Reset
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-card-code>
    <b-card-code
      title=""
      no-body
    >
      <!-- UPDATE DEVICE STATUS -->
      <b-modal
        id="modal-select2"
        v-model="modalShow"
        title="Update Device Status"
        cancel-variant="outline-secondary"
        :no-close-on-backdrop="true"
        hide-footer
        @cancel="() => {
          this.modalShow = false
        }"
      >
        <validation-observer ref="simpleRules">
          <b-form @submit.prevent>
            <b-row>
              <!-- Device -->
              <b-col
                cols="12"
                class="mt-1"
              >
                <h5>Device List</h5>
              </b-col>
              <b-col
                cols="12"
                class="mt-1 mb-1"
              >
                <div
                  v-for="(device, i) in checkedDevice"
                  v-if="checkedDevice.length > 0"
                  :key="i"
                  style="display: flex; align-items: start; column-gap: 0.5rem;"
                >
                  <p style="font-weight: bold;">
                    {{ device.name }}
                  </p> - <p>{{ device.code }}</p> - <p style="font-weight: bold;">
                    {{ device.serial_number }}
                  </p>
                </div>
                <div v-if="checkedDevice.length === 0">
                  <p style="font-weight: bold;">
                    Device is empty. please check the device
                  </p>
                </div>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Status"
                  label-for="v-Status"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Status"
                    rules="required"
                  >
                    <v-select
                      id="v-Status"
                      v-model="editService.serviceStatus"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="ServiceStatusOptions"
                      :reduce="(ServiceStatusOptions) => ServiceStatusOptions.value"
                      label="title"
                      placeholder="Service Status"
                      class="w-100"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Service Start Date"
                  label-for="v-ServiceStartDate"
                >
                  <b-input-group>
                    <flat-pickr
                      id="v-ServiceStartDate"
                      v-model="editService.serviceStartDate"
                      class="form-control"
                      :config="{ enableTime: false, time_24hr: false, enableClear: true, }"
                      placeholder="DD-MM-YYYY"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Service End Date"
                  label-for="v-ServiceEndDate"
                >
                  <b-input-group>
                    <flat-pickr
                      id="v-ServiceEndDate"
                      v-model="editService.serviceEndDate"
                      class="form-control"
                      :config="{ enableTime: false, time_24hr: false, enableClear: true, }"
                      placeholder="DD-MM-YYYY"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                class="mt-1 mb-1"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="isLoading || checkedDevice.length === 0"
                  @click.prevent="updateDeviceService"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
      <div>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="sidebar-right mr-2"
          variant="outline-primary"
          @click="() => {modalShow=true}"
        >
          <feather-icon icon="PlusIcon" /> Edit Service
        </b-button>
      </div>
      <div><div class="h-50 d-inline-block" /></div>
      <div class="d-flex justify-content-between flex-wrap">
        <!-- sorting  -->
        <b-form-group
          label="Sort"
          label-size="sm"
          label-align-sm="left"
          label-cols-sm="3"
          label-for="sortBySelect"
          class="ml-1"
        >
          <b-input-group size="sm">
            <b-form-select
              id="sortBySelect"
              v-model="sortBy"
              :options="sortOptions"
            >
              <template #first>
                <option value="">
                  none
                </option>
              </template>
            </b-form-select>
            <b-form-select
              v-model="sortDesc"
              size="sm"
              :disabled="!sortBy"
            >
              <option :value="false">
                Asc
              </option>
              <option :value="true">
                Desc
              </option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
        <!-- filter -->
        <b-form-group
          label="Filter"
          label-cols-sm="2"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mr-1"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="updateFilter.search"
              type="search"
              placeholder="Type to Search"
              @input="filterDevice"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <b-table
          striped
          hover
          responsive
          class="position-relative"
          :items="deviceItems"
          :fields="serviceFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #head(is_check)="">
            <div class="custom-header d-flex align-items-center">
              <b-form-checkbox
                v-model="selectAll"
                class="mr-2"
                @change="toggleSelectAllDevice"
              />
              <div class="selection-labels">
                <span
                  v-if="selectAll === false"
                  class="select-label"
                >
                  Select All
                </span>
                <span
                  v-else
                  class="select-label"
                >
                  Unselect All
                </span>
              </div>
            </div>
          </template>
          <template #cell(is_check)="data">
            <b-form-checkbox
              :id="`checkbox${data.index}`"
              v-model="data.item.is_check"
              :name="`checkbox-${data.index}`"
              :value="true"
              :unchecked-value="false"
              @input="() => {}"
            />
          </template>
          <template #cell(site_name)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(site_code)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(province_name)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(regency_name)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(district_name)="data">
            {{ data.value || '-' }}
          </template>
          <template #cell(service_start_date)="data">
            {{ formatDateData(data.value) }}
          </template>
          <template #cell(service_end_date)="data">
            {{ formatDateData(data.value) }}
          </template>
          <template #cell(service_status)="data">
            <b-badge :variant="serviceDeviceBadge[1][data.value]">
              {{ serviceDeviceBadge[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(device_status)="data">
            <b-badge :variant="statusBadge[1][data.value]">
              {{ statusBadge[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(installation_status)="data">
            <b-badge :variant="installationStatusBadge[1][data.value]">
              {{ installationStatusBadge[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(device_serial_number)="row">
            <b-link
              :to="{ path: '/temperature-device/detail/' + row.item.device_id }"
            >
              <span>{{ row.item.device_serial_number }}</span>
            </b-link>
          </template>
        </b-table>
        <p class="text-nowrap align-left">
          &nbsp;Total Rows {{ totalRows }}
        </p>
        <b-form-group
          label="Per Page"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
            @input="filterDevice"
          />
        </b-form-group>
        <p class="text-nowrap mb-md-0 mr-1 align-left" />
        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="filterDevice"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card-code>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCard, BTable, BFormCheckbox, BRow, BCol, BBadge, BForm, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, VBModal,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'
import { selectAll } from 'vue-context/src/js/utils'
import store from '@/store/index'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BCardCode,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BCol,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BLink,
    BForm,
    flatPickr,
  },
  data() {
    return {
      editService: {
        serviceStatus: null,
        serviceStartDate: null,
        serviceEndDate: null,
      },
      flatpickrConfig: {
        mode: 'range',
        enableTime: false,
        enableClear: true,
      },
      projectUndp: 0,
      select_device_type: null,
      select_status: null,
      dir: false,
      modalShow: false,
      currentPage: 1,
      perPage: 10,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      selectAll: false,
      indeterminate: false,
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      StatusOptions: [
        { title: 'Available', value: 'AC' },
        { title: 'Online', value: 'IN' },
        { title: 'Deleted', value: 'DL' },
        { title: 'Offline', value: 'ER' },
        { title: 'Error', value: 'FL' },
      ],
      ServiceStatusOptions: [
        { title: 'Active', value: 'ACTIVE' },
        { title: 'Expired', value: 'EXPIRED' },
        { title: 'Inactive', value: 'INACTIVE' },
      ],
      status: [{
        AC: 'Available', IN: 'Unavailable', DL: 'Deleted', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-success', IN: 'light-danger', DL: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      statusBadge: [
        {
          FL: 'Error',
          IN: 'Online',
          ER: 'Offline',
          DL: 'Deleted',
          AC: 'Available',
        },
        {
          FL: 'light-warning',
          IN: 'light-success',
          ER: 'light-secondary',
          DL: 'light-danger',
          AC: 'light-primary',
        },
      ],
      serviceDeviceBadge: [
        {
          ACTIVE: 'Active',
          INACTIVE: 'Inactive',
          EXPIRED: 'Expired',
          DL: 'Deleted',
          AC: 'Available',
        },
        {
          EXPIRED: 'light-warning',
          ACTIVE: 'light-success',
          INACTIVE: 'light-secondary',
        },
      ],
      installationStatusBadge: [
        {
          UI: 'Waiting Installation',
          IN: 'Approve',
          DF: 'Approve With Note',
          VF: 'Waiting Verif',
          RJ: 'Reject',
          CP: 'Complete',
        },
        {
          IN: 'light-warning',
          DF: 'light-success',
          VF: 'light-info',
          RJ: 'light-danger',
          CP: 'light-success',
        },
      ],
      updateFilter: {
        province: null,
        regency: null,
        site: null,
        service_status: null,
        start_date: null,
        end_date: null,
        device_type: null,
        status: null,
        search: null,
      },
      updateSite: {
        device: null,
        province: null,
        regency: null,
        district: null,
        site: null,
      },
      isLoading: false,
      required,
    }
  },
  computed: {
    ...mapState({
      items: state => state.device.items,
      totalRows: state => state.device.totalRows,
      serviceFields: state => state.device.serviceFields,
      deviceItems: state => state.device.deviceItems,
      pageOptions: state => state.device.pageOptions,
      DeviceTypeOptions: state => state.temperature.devicetypeoptions,
      province: state => state.region.province,
      regency: state => state.region.regency,
      district: state => state.region.district,
      sites: state => state.site.options,
      areas: state => state.region.area,
      locations: state => state.region.location,
      filteredDevices: state => state.device.filteredDevices,
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.serviceFields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // this.dir = true
        return this.dir
      }
      // this.dir = false
      return this.dir
    },
    checkedDevice() {
      return this.deviceItems.filter(item => item.is_check === true)
    },
    mapFilter() {
      return {
        province_id: this.updateFilter.province,
        regency_id: this.updateFilter.regency,
        site_id: this.updateFilter.site,
        start_date: this.updateFilter.start_date,
        end_date: this.updateFilter.end_date,
        service_status: this.updateFilter.service_status,
        device_type_id: this.updateFilter.device_type,
        status: this.updateFilter.status,
        page: this.currentPage,
        perPage: this.perPage,
        search: this.updateFilter.search,
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows = this.deviceItems.length
  },
  created() {
    this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
    this.$store.dispatch('region/province')
    this.$store.dispatch('temperature/getDeviceType')
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    resetFilter() {
      this.updateFilter = {
        province: null,
        regency: null,
        district: null,
        site: null,
        start_date: null,
        end_date: null,
        service_status: null,
        device_type: null,
        status: null,
        search: null,
      }
      this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.$store.state.totalActive = filteredItems.filter(f => f.status === 'IN').length
      this.$store.state.totalOffline = filteredItems.filter(f => f.status === 'ER').length
      this.$store.state.totalError = filteredItems.filter(f => f.status === 'FL').length
      this.currentPage = 1
    },
    toggleSelectAllDevice() {
      const isCheck = this.selectAll
      const changedDevice = this.deviceItems.map(item => ({ ...item, is_check: isCheck }))
      this.$store.dispatch('device/updateDeviceItems', changedDevice)
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    formatDateData(date) {
      if (date) return this.$options.filters.formatDateD(date)
      return '-'
    },
    filterDevice() {
      this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
      this.selectAll = false
    },
    onProvinceChange(selectedProvince) {
      this.$store.dispatch('region/regency', selectedProvince)
      this.$store.dispatch('site/setFilterProvince', selectedProvince)
    },
    onRegencyChange(selectedRegency) {
      this.$store.dispatch('region/district', selectedRegency)
      this.$store.dispatch('site/setFilterRegencyOnly', selectedRegency)
    },
    updateDeviceService() {
      this.show = true
      this.isLoading = true
      this.$refs.simpleRules.validate()
        .then(success => {
          if (success) {
            this.$store.dispatch('device/formUpdateService', { ...this.editService, deviceId: this.checkedDevice.map(item => item.id) })
              .then(res => {
                this.modalShow = false
                this.isLoading = false
                this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
                this.$store.dispatch('device/getFilteredDeviceList', this.mapFilter)
                this.editService = {
                  serviceStatus: null,
                  serviceStartDate: null,
                  serviceEndDate: null,
                }
                if (selectAll) this.selectAll = false
              },
              err => {
                this.modalShow = false
                this.isLoading = false
                this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                this.editService = {
                  serviceStatus: null,
                  serviceStartDate: null,
                  serviceEndDate: null,
                }
                if (selectAll) this.selectAll = false
              })
          } else {
            this.modalShow = false
            this.isLoading = false
            this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
          }
        })
    },
    onSiteChange(selectedSite) {
      this.$store.dispatch('region/area', selectedSite)
    },
    onAreaChange(selectedArea) {
      this.$store.dispatch('region/location', selectedArea)
    },
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
